import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Box} from 'reactjs-admin-lte'
import {Pagination,Button,ButtonToolbar,SplitButton,MenuItem,ControlLabel,InputGroup,FormGroup,Row,Col,FormControl,Form} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import StockStore from '../../stores/StockStore'
import SWTNewCustomerPopup from '../workdoc/SWTNewCustomerPopup'
import DatePicker from '../../component/element/DatePicker'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import PullStock from '../../component/element/PullStock'
import IframeModal from '../../component/element/IframeModal'
import CKAutocomplete from '../../component/element/CKAutocomplete'
import AutopartStore from '../../stores/AutopartStore'
import WorkdocStore from '../../stores/WorkdocStore'
import ReportStore from '../../stores/ReportStore';
import Moment from 'moment';
import SearchCarButton from '../../component/element/SearchCarButton'
import InputNumber from 'rc-input-number'
import RemarkRecordModal from 'component/element/RemarkRecordModal'
import StockEditProductModal from './StockEditProductModal'
import $ from 'jquery'
var NotificationSystem = require('react-notification-system');

const TODAY = Moment().format('L LT').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')) + 543);
const DEFAULT_ROW = 1
class StockNewMixColorDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initState()
    this.pcInput = new Array(DEFAULT_ROW).fill('')
    this._form_car_registration_no = new Array(DEFAULT_ROW).fill('')
    this.car_info_timestmap = Date.now()
  }

  initState(newState){
    
    let state = {
      activePage:1,
      totalPage:1,
      cur_data:[],
      pullStockShow:false,
      loading:false,
      showHistory:false,
      mpNo:'',      
      showNotice:false,
      shopName:'',
      rowBeep:-1,
      data:this.newEmptyRow(DEFAULT_ROW),
      options:[],
      doc:this.getEmptyDoc(),
      input:{car_registration_no:'',response_by:'',request_by:''},
      car_registration_no_list:[],
      stockApproverList:[],
      customerList:[],
      car_info:'',
      bf_queue_id:undefined,
      form_car_registration_no_list:[],
      showCar:false,
      car_index:undefined,
      showRemark:false,
      edit_index:undefined,
      showStockPopup:false,
      dataSet:{},
      productImages:[],
      _latestEndQuantity:undefined,
      emptyBeginQuantity:false,
      beginQtyList:new Array(DEFAULT_ROW).fill([])
    }

    if(newState!==undefined){
      state = Object.assign(state,newState)
    }
    return state
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;  
  }


  componentWillMount() {
    // Instantiate a Realtime client
    
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.doc!==undefined){
      if(newProps.doc.doc_no!==''){
        //console.log('onRe',newProps.doc)    
        this.setState({doc:newProps.doc,car_info:newProps.doc.brand+'/'+newProps.doc.model})
      }else{
        //console.log('onEmptyDoc')
        this.setState({doc:this.getEmptyDoc(),car_info:'',data:this.newEmptyRow(DEFAULT_ROW)})        
      }
      
    }

    if(newProps.show && newProps.show!==this.props.show){
      $('body').on('click', ()=> { 
        if ($('.tdDropdownTec > div > div').hasClass('ck-autocomplete-box')) {
          $('.table-responsive').css( "overflow-x", "initial" );
          $('.table-responsive').css( "overflow-y", "unset" );
        } else {
          $('.table-responsive').css( "overflow-x", "auto" );
          $('.table-responsive').css( "overflow-y", "" );
        }  
      });
  
      $('body').on('click', ()=> {
        if ($('.tdDropdownCar > div > span > div > div').hasClass('ck-autocomplete-box')) {
          $('.table-responsive').css( "overflow-x", "initial" );
          $('.table-responsive').css( "overflow-y", "unset" );
        }  
      });
      $('body').on('keydown', '.tdDropdownCar > div > span > div > input', ()=> { 
        $('.table-responsive').css( "overflow-x", "initial" );
        $('.table-responsive').css( "overflow-y", "unset" );
      });

      this.loadWorkdocAutocompleteOfficer()
      this.loadWorkdocAutocompleteStockApprover()
      if(newProps.doc.doc_no!==''){
        this.loadData(newProps.doc.doc_no)
      }
    }
  }

  getValidateCar(item){
    if(item.car_registration_no!='' && item.work_no==''){
      return "warning"
    }else{
      return null
    }
    
  }

  loadCarRegistrationNo(doc) {
    let {car_registration_no_list} = this.state
    let that = this
    let car = []
    if(doc.car_registration_no!==undefined && doc.car_registration_no.length>=2 && (Date.now() - that.car_info_timestmap)>2000){
      StockStore.loadCarRegistrationNo(doc.car_registration_no,function(result) {
        result.data.forEach(element => {
          car.push({
            id: element.Value,
            label: element.Name,
            car_info: element.car_info,
            work_no :element.work_no
          })
        });
        that.setState({car_registration_no_list:car})
        that.car_info_timestmap = Date.now()
      })
    }
  }

  loadFormCarRegistrationNo(index) {
    let {data,form_car_registration_no_list} = this.state
    let that = this
    let car = []
    
      StockStore.loadCarRegistrationNo(data[index].car_registration_no,function(result) {
        result.data.forEach(element => {
          car.push({
            id: element.Value,
            label: element.Name,
            car_info: element.car_info,
            work_no :element.work_no
          })
        });
        data[index].work_no = ''
        that.setState({data:data,form_car_registration_no_list:car})
      })

  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name,
          emp_id: element.employee_id
        })
      });
      that.setState({customerList:officer})
    })  
  }

  loadWorkdocAutocompleteStockApprover() {
    let that = this
    let approver = []
    WorkdocStore.loadWorkdocAutocompleteStockApprover(function(result){
      result.data.forEach(element => {
        approver.push({
          id: element.Value,
          label: element.Name
        })
      });
      that.setState({stockApproverList:approver})
    })  
  }

  subscribeDocChannel(channel){
         
  }

  isLastItemSaved(){
    let {data} = this.state
    let last = data[data.length-1]

    if(last.bf_mixedcolor_item_id>0){
      if(last.begin_quantity*1>0)
        return true
      else return false
    }else{
      return false
    }
  }

  renameDoc(newSoNo){
    let {doc} = this.state
    
    this.setState({mpNo:newSoNo,doc:doc})
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {serial_no:'',colorcode:'',end_quantity:'',begin_quantity:'',unit:'',remark:'',productcode:'',itemcode:'',employee_id:'',used_date:TODAY,used_time:Moment().format('HH:mm')}
    })
  }

  getEmptyDoc(){
    return {work_no:'',colorcode:'',doc_no:'',description:'',response_by:'',request_by:''}
  }

  getLatestEndQuantity(data) {
        let latestEndQuantity = ''
        data.forEach((item,sindex)=>{
          // if(data.length-1==sindex) {
          if(item.end_quantity!=''&&item.end_quantity!=null&&item.end_quantity!=undefined&&!isNaN(item.end_quantity)) {  
            latestEndQuantity = item.end_quantity
          }
        })
        latestEndQuantity = (latestEndQuantity==0&&latestEndQuantity!=''?'0':latestEndQuantity)
        return latestEndQuantity
  }

  getEmptyBeginQuantity(data) {
    let emptyBeginQuantity = false
    data.forEach((item,index)=>{
      if (item.begin_quantity==''||item.begin_quantity==null||item.begin_quantity==undefined||isNaN(item.begin_quantity))
        emptyBeginQuantity = true
    })
    return emptyBeginQuantity
  }

  handleSelect(pageSelect) { 
    let {cur_data} = this.state
    if (cur_data.length > 10) {
      let data = []
      let end = (pageSelect * 20) - 1
      let start = end - 19
      for (var i=start;i<=end;i++) {
        if (i<cur_data.length) {
          data.push(cur_data[i])
        }
      }
      this.setState({activePage:pageSelect, data:data})
    }
  }

  loadData(mpNo) {
    
    let that = this
    this.setState({ loading: true, mpNo: mpNo })
    StockStore.loadMixColorItem(mpNo, function (result) {
      let data = result.data
      let beginQtyList = new Array(data.length).fill([])
      // if (result.data.length < DEFAULT_ROW) {
      //   data = data.concat(that.newEmptyRow(DEFAULT_ROW - result.data.length))
      // }
      // ReactDOM.findDOMNode(that.pcInput[result.data.length]).focus();
      that.pcInput = new Array(data.length).fill('')
      // data = data.map((item,index)=>{
      //   if (item.begin_quantity=='0')
      //     item.begin_quantity = ''
      //   if (item.end_quantity=='0')
      //     item.end_quantity = ''  
      //     return item
      // })
      let _latestEndQuantity = that.getLatestEndQuantity(data)
      let emptyBeginQuantity = that.getEmptyBeginQuantity(data)
      that.setState({ loading: false,  data: data,_latestEndQuantity:_latestEndQuantity,emptyBeginQuantity:emptyBeginQuantity,beginQtyList:beginQtyList})
    })
  }

  onStockEditProductCloseClick() {
    this.setState({showStockPopup:false,dataSet:{}})
  }

  onStockEditProductCategoryChange(e) {
    let {dataSet} = this.state
    dataSet['cat_id'] = e
    this.setState({dataSet:dataSet})
  }

  onTextStockEditProductChange(e) {
    let dataSet = this.state.dataSet
    dataSet[e.key] = e.value
    this.setState({dataSet:dataSet})
  }

  onImageUpload(complete) {
    let {doc} = this.state
    if (doc.stock_itemnum>0) {
      let that = this
      StockStore.loadImages(doc.stock_type,doc.stock_itemnum,function(result) {
        that.setState({ productImages:result.data.files})
        if (complete!=undefined) {
          let callBack = {status:'OK',data:result.data.files}
          complete(callBack)
        }
      })
    }
  }

  

  onCustomerClick(){
    //this.setState({show:true})
  }

  onInputChange(key,e){
    let {doc} = this.state
    doc[key] = e.target.value
    this.setState({doc:doc})
  }

  onCustomerPageSelect(item){
    let {doc} = this.state
    doc['customer_id'] = item.customer_id
    doc['customer_name'] = item.name
    doc['customer_address'] = item.address
    this.setState({doc:doc})
  }

  onDateChange(value){
    let {doc} = this.state
    doc['added_date'] = value
    this.setState({doc:doc})
  }

  

  onSaveClick(){
    let {doc,data} = this.state
    this.saveStockMixPaint(doc,data)  
  }

  saveStockMixPaint(doc,data){
    let that = this
    this.setState({loading:false})
    let postData = {doc:doc,itemlist:data}
    
    StockStore.saveStockMixColorItem(postData,function(result){
      if(result.status==='OK'){
        doc.doc_no = result.id
        result.data.itemlist.forEach((item,index)=>{
          data[index] = Object.assign({bf_mixedcolor_item_id:item.bf_mixedcolor_item_id},data[index])
          delete data[index]['is_request_edit']
        })
        that.setState({loading:false,doc:doc,data:data})
        that._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message: 'บันทึกรายการสำเร็จ',
          level: 'info',
          position:'tc'
        });
      }
    },function(error){
      that.setState({loading:false})
      that._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message: 'ทำการบันทึกไม่สำเร็จ',
        level: 'error',
        position:'tc'
      });
    }) 
  }

  onCloseClick(){
    //SubscribeStore.unsubscribe()
    
    if(this.props.onClose!==undefined){
      this.props.onClose()
    }
  }

  getTotalPage() {
    let {cur_data} = this.state
    let totalPage = cur_data.length / 20
    totalPage = Math.round(totalPage)
    this.setState({totalPage:totalPage})
  }
  
  onDeleteRowClick(index){ 
    let {data,cur_data,beginQtyList,_latestEndQuantity} = this.state
    cur_data.splice(index,1)
    data.splice(index,1)
    beginQtyList.splice(index,1)
    _latestEndQuantity = this.getLatestEndQuantity(data)
    data.forEach((item,index)=>{
      if (index>0) {
        beginQtyList[index] = [{label:data[index-1].end_quantity.toString(),id:data[index-1].end_quantity.toString()}]
      }
    })
    this.setState({data:data,cur_data:cur_data,beginQtyList:beginQtyList,_latestEndQuantity:_latestEndQuantity})    
  }

  summaryAmount(data){
    let amount = 0
    data.map((item,index)=>{
      amount += item.amount*1
    })
    return amount
  }

  onFormChange(index,key,e){
    let {doc,data,_latestEndQuantity,emptyBeginQuantity,beginQtyList} = this.state
    let value = (key=='end_quantity'?e:e.target.value)
    data[index][key] = value
    if(['end_quantity','begin_quantity'].includes(key)){
      if (key=='begin_quantity') {
        data[index][key] = data[index][key].replace(/,/g, '')
        let begin_quantity = data[index].begin_quantity==undefined?0:data[index].begin_quantity
        let end_quantity = data[index].end_quantity==undefined?0:data[index].end_quantity
        if (end_quantity>begin_quantity) {
          data[index].end_quantity = ''
          this._notificationSystem.addNotification({
            title:'แจ้งเตือน',
            message: 'น้ำหนักชั่งหลังเบิก ต้องไม่มากกว่าน้ำหนักชั่งก่อนเบิก',
            level: 'error',
            position:'tc'
          });
        }
        let latestEndQuantity = 0
        let latestEndQuantityIndex = undefined
        data.forEach((item,sindex)=>{
          if(item.end_quantity!=''&&item.end_quantity!=null&&item.end_quantity!=undefined&&!isNaN(item.end_quantity)) {
            latestEndQuantity = item.end_quantity
            latestEndQuantityIndex = sindex
            _latestEndQuantity = item.end_quantity
          }  
        })
        if (data[index].begin_quantity>0) {
          data[index] = Object.assign({is_request_edit:true},data[index])
        }
        this.setState({_latestEndQuantity:_latestEndQuantity})
        if ((data[index][key]*1)>(latestEndQuantity*1)&&(latestEndQuantity*1)>0&&index>latestEndQuantityIndex) {
          data[index][key] = ''
          this._notificationSystem.addNotification({
            title:'แจ้งเตือน',
            message: 'น้ำหนักชั่งก่อนเบิก ต้องไม่มากกว่าน้ำหนักชั่งหลังเบิกล่าสุด',
            level: 'error',
            position:'tc'
          });
        }  
        emptyBeginQuantity = this.getEmptyBeginQuantity(data)
        this.setState({emptyBeginQuantity:emptyBeginQuantity})
      } else if (key=='end_quantity') {
        data[index].begin_quantity = data[index].begin_quantity.replace(/,/g, '')
        let begin_quantity = data[index].begin_quantity==undefined?0:data[index].begin_quantity
        let end_quantity = data[index].end_quantity==undefined?0:data[index].end_quantity
        if (end_quantity>begin_quantity) {
          data[index][key] = ''
          this._notificationSystem.addNotification({
            title:'แจ้งเตือน',
            message: 'น้ำหนักชั่งหลังเบิก ต้องไม่มากกว่าน้ำหนักชั่งก่อนเบิก',
            level: 'error',
            position:'tc'
          });
        }  
        _latestEndQuantity = this.getLatestEndQuantity(data)
        data.forEach((sitem,sindex)=>{
          if (sindex>0) {
            beginQtyList[sindex] = [{label:_latestEndQuantity.toString(),id:_latestEndQuantity.toString()}]
          }
        })
        
        data.forEach((sitem,sindex)=>{
          if (sindex>index&&sitem.begin_quantity>_latestEndQuantity) {
            data[sindex].begin_quantity = ''
            data[sindex].end_quantity = ''
          }  
        })  
        
        this.setState({_latestEndQuantity:_latestEndQuantity,beginQtyList:beginQtyList})
      }
      data[index]['begin_quantity'] = (data[index]['begin_quantity']==undefined||data[index]['begin_quantity']==null||isNaN(data[index]['begin_quantity'])?'':data[index]['begin_quantity'])
      data[index]['end_quantity'] = (data[index]['end_quantity']==undefined||data[index]['end_quantity']==null||isNaN(data[index]['end_quantity'])?'':data[index]['end_quantity'])
      data[index]['used_quantity'] = (data[index]['begin_quantity']*1 - data[index]['end_quantity']*1)
      data[index]['used_quantity'] = (data[index]['used_quantity']==undefined||data[index]['used_quantity']==null||isNaN(data[index]['used_quantity'])?'':data[index]['used_quantity'])
    } else if (key=='car_registration_no') {
      this.loadFormCarRegistrationNo(index)
    }

    this.setState({doc:doc,data:data})
  }

  onRowAdd(number){
    let {data,_latestEndQuantity,beginQtyList} = this.state
    data = data.concat(this.newEmptyRow(number))
    this.pcInput = new Array(data.length).fill('')
    
    if (data.length==1)
      beginQtyList.push([])
    else
      beginQtyList.push([{label:_latestEndQuantity.toString(),id:_latestEndQuantity.toString()}])
    this.setState({data:data,beginQtyList:beginQtyList})
  }


  onSearch(index,query){
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartItemList(-1,query,function(result){
      //console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,unit:item.unit,quantity:item.quantity,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit}
      })
      that.setState({options:options})
    })
    
    //this.setState({options:options})
  }


  onProductCodeSearch(index,query){
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockCodePartItemList(-1,query,function(result){
      //console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit}
      })
      that.setState({options:options})
    })
  }

  onTypeaheadChange(index,option){
    //console.log('options',index,option)

    let {data,doc} = this.state
    if(option.length===1){
      data[index].detail = option[0].detail
      data[index].quantity = 1
      if(option[0].itemnum!==undefined){
        data[index].amount = option[0].pricePerUnit
        data[index].itemnum = option[0].itemnum      
        data[index].stock_quantity = option[0].quantity  
        data[index].productcode = option[0].productCode
        data[index].price_per_unit = option[0].pricePerUnit
      }
      doc['amount'] = this.summaryAmount(data)
    }
    //console.log('typeahead',data)
    this.setState({data:data,doc:doc})
  }

  onTextKeyPress(index,key,target) {
    if(target.charCode==13){
      this.onSaveClick()
    }
  }


  onSearchCarKeyPress(e) {
    if (e.charCode == 13) {
      let {doc} = this.state
      let that = this
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){   
          doc.work_no =  item.work_no         
          doc.car_registration_no = item.car_registration_no              
          that.setState({doc:doc,car_info:item.car_info})
          // that._description.focus()
        }else{
          doc.work_no = ''
          doc.car_registration_no = '';
          that.setState({doc:doc,car_info:'ไม่พบทะเบียนรถ'})
        }
      })
    }
  }

  onWorkSearchCarKeyPress(index,e) {
    if (e.charCode == 13) {
      let {data} = this.state
      let that = this
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){
          data[index].car_registration_no = item.car_registration_no
          data[index].car_info = item.car_info   
          that.setState({data:data})
        }else{
          data[index].work_no = ''
          data[index].car_registration_no = ''
          data[index].car_info = ''
          that.setState({data:data})
          that._notificationSystem.addNotification({
            title:'แจ้งเตือน',
            message: 'ไม่พบทะเบียนรถ',
            level: 'error',
            position:'tc'
          });
        }
      })
    }
  }

  onSearchKeyPress(index,key,target) {
    if(target.charCode==13){
      let {doc,data,showNotice} = this.state
      // console.log("code enter",data[index])    
      let that = this,foundIndex = -1
      let productcode = data[index][key];
      //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      //Finding duplicate
      
      data.map((item,iindex)=>{
        if(item.productcode===productcode && iindex!==index){
          foundIndex = iindex
        }
      })
      if(foundIndex>=0){
        
        data[index].productcode = ''
        
      }else{
        this.setState({loading:true})
        
        AutopartStore.loadStockProductCode('color',productcode,function(result){
          //console.log(result)
          //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
          if(result.data.length>0){
            let item = result.data[0]                           
            data[index].productcode = item.productcode
            data[index].colorcode = item.description
            

            if(index===data.length-1){
              //End index
              data = data.concat(that.newEmptyRow(1))
              that.pcInput[index+1] = ''
            }
            that.setState({loading:false,data:data})
            // ReactDOM.findDOMNode(that.pcInput[index+1]).focus();
            
          }else{
            data[index].productcode = ''
            that.setState({loading:false,data:data})
            that._notificationSystem.addNotification({
              title:'แจ้งเตือน',
              message: 'ไม่พบรหัสซีเรียล '+productcode+' ไม่พบในคลังสินค้า',
              level: 'warning',
              position:'tc'
            });
          }
        })      
      }
      this.setState({data:data,rowBeep:foundIndex})
        setTimeout(function(){ 
          that.setState({rowBeep:-1})
        }, 1500);
    }
    
  }


  onMenuItemSelect(index){
    let {soNo,doc} = this.state
    let that = this
    if('clearlist'===index){
      this.setState({clearShow:true})
    }else if("adjuststock"===index){
      this.setState({stockShow:true})      
    }else if("print"===index){
      let url = ''
      if (process.env.NODE_ENV == "development") {
        url  = './?startPage=PrintReportStockCheck&type='+this.props.stockType
      } else{
        url = './pdf/v2/?startPage=PrintReportStockCheck&type='+this.props.stockType
      }
      this.refs.iframe.loadUrl(url)
    }else if ("pullstock"==index) {
      this.setState({pullStockShow:true})
    }
  }

  onConfirmStockClear(){
    this.setState({clearShow:false,data:this.newEmptyRow(DEFAULT_ROW)})
    this.saveStockCheck([])
  }

  onConfirmStockSave(){
    let {soNo,data} = this.state 
    let that = this
    StockStore.requestStockAdjust(this.props.stockType,data,function(result){
      data = data.map((item,index)=>{
        item.stock_quantity = item.quantity
        return item
      })
      that.setState({stockShow:false,data:data})
      that._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message: 'ทำรายการปรับจำนวนสินค้าในคลังเรียบร้อยแล้ว',
        level: 'info',
        position:'tc'
      });
    },function(){
      that.setState({stockShow:false})
    })
  }

  onTextBlur(index,e) {
    let {data} = this.state
    let that = this
    that.setState({loading:false})
    StockStore.loadMixpaintItemcode(data[index].productcode,e.target.value,function(result) {
      if (result.data.length>0) {
        data[index].last_quantity = result.data[0].end_quantity
      } else {
        data[index].last_quantity = ''
      }
      that.setState({data:data,loading:false})
    })
  }

  onDataChange(cat_id) {
    let that = this

    ReportStore.loadStockList(this.props.stockType, "", cat_id, "", "", "", function(result) {
      // that.setState({data:result.data})
      let data = result.data.map((item,index)=>{
        item.stock_quantity = item.quantity
        item.quantity = ''
        item.detail = item.description
        return item
      })

      if(data.length <10) {
        data = data.concat(that.newEmptyRow(10-data.length))
        that.setState({data:data, totalPage:1})
        that.saveStockCheck(data)
      } else {
        let all_data = data
        let totalPage = all_data.length / 20
        totalPage = Math.round(totalPage)
        if (totalPage > 1) {
          data = []
          for (var i=0;i<20;i++) {
            data.push(all_data[i])
          }
        } else {
          totalPage = 1
        }
        that.setState({data:data, totalPage:totalPage, cur_data:all_data})
        that.saveStockCheck(all_data)
      }

      that._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message: 'ดึงข้อมูลเรียบร้อย',
        level: 'info',
        position:'tc'
      });
      //console.log('result',result)
    })
  }

  onFormSelect(index,key,e,eitem) {
      let {data,form_car_registration_no_list} = this.state
      if (key=='car_registration_no') {
        let new_car_registration_no_list = []
        new_car_registration_no_list.push(eitem)
        form_car_registration_no_list.forEach(function(item,index) {
          if (item.work_no!==eitem.work_no) {
            new_car_registration_no_list.push(item)
          }
        })   
        data[index][key] = eitem.id
        data[index].car_info = eitem.car_info
        data[index]['work_no'] = eitem.work_no
        this.setState({data:data,form_car_registration_no_list:new_car_registration_no_list})
      } else if (key=='technician') {
        data[index][key] = e
        data[index].employee_id = eitem.emp_id
        this._form_car_registration_no[index].onFocus()
        this.setState({data:data})
      } else if (key=='begin_quantity') {
        data[index][key] = e
        this.setState({data:data})
      }  
  }

  onFormSearchCarKeyPress(index,e) {
    if (e.charCode == 13) {
      let {data} = this.state
      let that = this
      let query = e.target.value
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){   
          data[index]['work_no'] =  item.work_no         
          data[index]['car_registration_no'] = item.car_registration_no
          data[index]['car_info'] = item.car_info              
          that.setState({data:data})
        }else{
          data[index]['work_no'] = ''
          data[index]['car_registration_no'] = ''
          data[index]['car_info'] = ''
          that.setState({data:data})
          that._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ไม่พบรหัส ' + query + ' กรุณาลองใหม่',
            level: 'error',
            position: 'tc'
          });
        }
      })
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getValidationState() {
    const length = this.state.shopName.length;
    if (length > 10) return 'success';
    else if (length > 5) return 'warning';
    else if (length > 0) return 'error';
  }

  _renderMenuItemChildren(option, props, index) {
    let quantityTitle = ''
    if(option.quantity>0){
      quantityTitle = ' มีจำนวน '+option.quantity+' '+option.unit
    }

    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} (หมวด{option.categoryName}) - {option.pricePerUnit} บาท {quantityTitle}</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail} {quantityTitle}</span>
        </div>
      );
    }
  }


  renderRemark(){
    let {description} = this.state.doc
    return (
      <Row>
      <Col md={3}>
        <FormGroup
          controlId="formBasicText"
          validationState={this.getValidationState()}
        >
          <ControlLabel>หมายเหตุ </ControlLabel>
          <InputGroup>            
            <FormControl value={description} componentClass="textarea" style={{width:'400px',height:'150px'}}
             onChange={this.onInputChange.bind(this,'description')}/>            
          </InputGroup>            
        </FormGroup>
      </Col>
      </Row>
    )
  }

  getRowClassName(item,index){
    
    return ''
  }

  onHideClick(e) {
    this.setState({pullStockShow:e})
  }

  onPrintClick(){

  }

  onHeadInputChagne(field,e){
    let {doc} = this.state
    doc[field] = e.target.value

    this.setState({doc:doc})
  }

  onFormSearchEmpKeyPress(index,e) {
    if (e.charCode==13) {
      e.preventDefault()

      let {customerList,data} = this.state
      let checkSearch = false
      let value = ''
      let emp_id = ''
      customerList.forEach(function(item,index) {
        if (item.emp_id===e.target.value) {
          checkSearch = true
          value = item.id
          emp_id = item.emp_id
        }
      })

      if (checkSearch) {
        data[index].technician = value
        data[index].employee_id = emp_id
        this._form_car_registration_no[index].onFocus()
      } else { 
        data[index].technician = ''
        this._notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'ไม่พบรหัส ' + e.target.value + ' กรุณาลองใหม่',
          level: 'error',
          position: 'tc'
        });
      }  
      this.setState({data:data})
    }
  }

  getBeginQuantityDisabled(item) {
    if (item.begin_quantity==''||item.begin_quantity==null||item.begin_quantity=='0'||item.begin_quantity==0||item.begin_quantity==undefined||isNaN(item.begin_quantity)) {
      return false
    } else {
      if ((item.bf_mixedcolor_item_id>0)&&(item.is_request_edit==undefined||!item.is_request_edit)) {
        return true
      } else {
        return false
      }
    }
  }

  getDisabled(bf_mixedcolor_item_id) {
    if (bf_mixedcolor_item_id>0)
      return true
    else
      return false  
  }

  onShowRemarkClick(index) {
    this.setState({showRemark:true,edit_index:index})
  }

  onFormDateChange(index,e) {
    let {data} = this.state
    data[index].used_date = e
    this.setState({data:data})
  }

  renderRowData(){
    let {data,customerList} = this.state
    if (data.length==0)
      return (<tr><td colSpan={9}>ไม่พบข้อมูล</td></tr>)
    return data.map((item,index)=>(
      <tr key={index} className={this.getRowClassName(item,index)}>
        <td className='text-center'>{index+1}</td>
        <td className='text-center'>
              <DatePicker
                  // disabled={(this.getDisabled(item.bf_mixedcolor_item_id)&&(item.is_request_edit==undefined||!item.is_request_edit))?true:false}
                  // disabledCalendarIcon={(this.getDisabled(item.bf_mixedcolor_item_id)&&(item.is_request_edit==undefined||!item.is_request_edit))?true:false}
                  disabled={this.getBeginQuantityDisabled(item)}
                  disabledCalendarIcon={this.getBeginQuantityDisabled(item)}
                  value={item.used_date==null?'':item.used_date}
                  onChange={this.onFormDateChange.bind(this,index)}
                  showIcon={true}
                  showFooter={true}
                  buddhistEra={true}
                />
        </td>
        <td className='text-center'>
          <FormControl 
            disabled={this.getBeginQuantityDisabled(item)}
            value={item.used_time}/>
        </td>
        <td className='tdDropdownTec'>
          <CKAutocomplete
            // disabled={(this.getDisabled(item.bf_mixedcolor_item_id)&&(item.is_request_edit==undefined||!item.is_request_edit))?true:false}
            disabled={this.getBeginQuantityDisabled(item)}
            top={'-35px'}
            items={customerList}
            value={item.technician}
            onChange={this.onFormChange.bind(this,index,'technician')}
            onSelect={this.onFormSelect.bind(this,index,'technician')}
            onKeyPress={this.onFormSearchEmpKeyPress.bind(this,index)}
          />          
        </td>
        <td className='text-center tdDropdownCar'>
              <FormGroup controlId="formValidationWarning3" validationState={this.getValidateCar(item)}>
                <InputGroup>
                  <CKAutocomplete
                    // disabled={(this.getDisabled(item.bf_mixedcolor_item_id)&&(item.is_request_edit==undefined||!item.is_request_edit))?true:false}
                    disabled={this.getBeginQuantityDisabled(item)}
                    choiceStyle={{width:'350px'}}
                    items={this.state.form_car_registration_no_list}
                    value={item.car_registration_no}
                    onChange={this.onFormChange.bind(this,index,'car_registration_no')}
                    onSelect={this.onFormSelect.bind(this,index,'car_registration_no')}
                    onKeyPress={this.onFormSearchCarKeyPress.bind(this,index)}
                    ref={(input) => { this._form_car_registration_no[index] = input; }}
                  />
                  {/* <InputGroup.Addon style={{pointerEvents:(this.getDisabled(item.bf_mixedcolor_item_id)&&(item.is_request_edit==undefined||!item.is_request_edit))?'none':'',backgroundColor:(this.getDisabled(item.bf_mixedcolor_item_id)&&(item.is_request_edit==undefined||!item.is_request_edit))?'#eee':''}} className="btn" onClick={()=>this.setState({showCar:true,car_index:index})}> */}
                  <InputGroup.Addon style={{pointerEvents:this.getBeginQuantityDisabled(item)?'none':'',backgroundColor:this.getBeginQuantityDisabled(item)?'#eee':''}} className="btn" onClick={()=>this.setState({showCar:true,car_index:index})}>
                    <FontAwesome name='plus' />
                  </InputGroup.Addon>
                </InputGroup>
              </FormGroup>
        </td>
        <td  className='text-center'>{item.car_info}</td>                      
        <td  className='text-center tdDropdownBeginQty'>
          {/* <InputNumber
            disabled={this.getBeginQuantityDisabled(item)}
            className='input-number-format text-center'
            value={item.begin_quantity} 
            onChange={this.onFormChange.bind(this, index, 'begin_quantity')}
            formatter={value =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
          /> */}
          <CKAutocomplete
            disabled={this.getBeginQuantityDisabled(item)}
            top={'-35px'}
            items={this.state.beginQtyList[index]}
            value={item.begin_quantity.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            // value={item.begin_quantity}
            onChange={this.onFormChange.bind(this,index,'begin_quantity')}
            onSelect={this.onFormSelect.bind(this,index,'begin_quantity')}
            isNumberFormat={true}
            textAlign='text-center'
          /> 
        </td>
        <td  className='data-column text-center'>
          <InputNumber
            // disabled={(this.getDisabled(item.bf_mixedcolor_item_id)&&(item.is_request_edit==undefined||!item.is_request_edit))?true:false}
            disabled={this.getBeginQuantityDisabled(item)}
            className='input-number-format text-center'
            value={item.end_quantity} 
            onChange={this.onFormChange.bind(this, index, 'end_quantity')}
            formatter={value =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
          />
        </td>
        <td className='text-center'>{item.used_quantity!=''&&item.used_quantity!=null&&item.used_quantity!=undefined?this.getNumberFormat(item.used_quantity):''}</td>
        <td className='text-center'>
          {/* {(this.getDisabled(item.bf_mixedcolor_item_id)&&(item.is_request_edit==undefined||!item.is_request_edit))?<Button bsStyle={'primary'} onClick={this.onShowRemarkClick.bind(this,index)}><FontAwesome name='pencil'/></Button> */}
          {this.getBeginQuantityDisabled(item)?<Button bsStyle={'primary'} onClick={this.onShowRemarkClick.bind(this,index)}><FontAwesome name='pencil'/></Button>
          :<Button bsStyle={'danger'} onClick={this.onDeleteRowClick.bind(this,index)}><FontAwesome name='close'/></Button>}
        </td>
      </tr>
    ))

  }


  renderTable(){
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid' style={{minWidth:'1280px',marginBottom:'0'}}>
          <thead>
            <tr >
              <th className='text-center' style={{width:'30px'}}>ลำดับ</th>
              <th className='text-center' style={{minWidth:'150px',width:'150px'}}>วันที่</th>
              <th className='text-center' style={{minWidth:'80px',width:'80px'}}>เวลา</th>
              <th className='text-center' style={{width:'100px'}}>ช่างเบิก</th>
              <th className='text-center' style={{width:'150px'}}>ทะเบียนรถ</th>
              <th className='text-center' style={{width:'120px'}}>รุ่นรถ</th>            
              <th className='text-center' style={{width:'100px'}}>น้ำหนักก่อน</th>
              <th className='text-center' style={{width:'100px'}}>น้ำหนักหลัง</th>     
              <th className='text-center' style={{width:'100px'}}>ใช้ไป</th>            
              <th className='text-center' style={{width:'30px'}}>ลบ?</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr >            
              <th colSpan={5} className='text-right'>รวมจำนวนรายการ</th>
              <th colSpan={4} ></th>
          </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  renderNewItemButton(){
    return (
      <div style={{display:'inline-flex'}}>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการ</Button>
          {/* <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;เพิ่ม 10 รายการ</Button> */}
        </ButtonToolbar>       
      </div>
    )
  }

  
  renderStockStatus(){
    let {doc} = this.state
    if(doc.stock_recordid*1>0){
      return (<span className='label label-default'>ตัดสต๊อกแล้ว</span>)
    }else{
      return (<span/>)
    }
  }

  onTextChange(key,e) {
    let {doc} = this.state

    if (doc==="")
      doc = this.getEmptyDoc()

    doc[key] = e.target.value
    this.setState({doc:doc})
    if (key=='car_registration_no') {
      this.loadCarRegistrationNo(doc)
      if(e.target.value==='')
        this.setState({car_info:''})
    }
  }

  onTextSelect(key, e) { 
    let {doc,car_registration_no_list} = this.state

    if (doc==="")
      doc = this.getEmptyDoc()
    
    if (key=='car_registration_no') {
      let value = ''
      let car_info = ''
      
      car_registration_no_list.forEach(function(item,index) {
        if(e===item.label) {
          value = item.id
          car_info = item.car_info
          doc.work_no =  item.work_no
        }  
      })

      doc[key] = value      
      this.setState({doc:doc,car_info:car_info})
      // this._description.focus()
    } else {
      doc[key] =  e
      this.setState({doc:doc})

      if (key=='mixed_by')
        this.refs._request_by.onFocus()
      else if (key=='request_by')
        this.refs._response_by.onFocus()
      else if (key=='response_by')
        this.refs._car_registration_no.onFocus()
    }
  }

  onEmpTextKeyPress(key,e) {
    if (e.charCode == 13) {
      e.preventDefault()

      let {customerList,doc} = this.state
      let checkSearch = false
      let value = ''

      customerList.forEach(function(item,index) {
        if (item.emp_id===e.target.value) {
          checkSearch = true
          value = item.id
        }
      })

      if (checkSearch) {
        if (key=='request_by') {
          doc[key] = value
          this.refs._response_by.onFocus()
        } else if (key=='response_by') {
          doc[key] = value
          this.refs._car_registration_no.onFocus()
        } else if (key=='mixed_by') {
          doc[key] = value
          this.refs._request_by.onFocus()
        }
      } else { 
        doc[key] = ''

        this._notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'ไม่พบรหัส ' + e.target.value + ' กรุณาลองใหม่',
          level: 'error',
          position: 'tc'
        });
      }  
      this.setState({doc:doc})
    }  
  }

  onSetWorkNo(item) {
    let {doc,data} = this.state
    doc.work_no = item.work_no
    doc.car_registration_no = item.car_registration_no
    doc.request_by = item.mixed_by
    doc = Object.assign({bf_queue_id:item.bf_queue_id}, doc)
    this.setState({doc:doc,car_info:item.car_info,bf_queue_id:item.bf_queue_id})
    if (item.mixpaint_no=='0')
      this.saveStockMixPaint(doc,data)
    else
      this.loadData(item.mixpaint_no)  
  }

  onCarSearchSelect(e) {
    let {data,car_index} = this.state
    data[car_index]['car_registration_no'] = e.Value  
    data[car_index]['work_no'] = e.work_no
    data[car_index]['car_info'] = e.car_info
    setTimeout(()=>{
     this.setState({data:data,car_index:undefined})
    },100)
  }

  onUpdateData(item) {
    let {doc} = this.state
    doc.stock_description = item.description
    doc.cost_per_unit = item.cost_per_unit
    doc.location = item.location
    doc.remark = item.remark
    this.setState({doc,doc})
  }

  onClearAfterSave() {
    this.setState({dataSet:{}})
  }

  onJobDoneClick() {
    let {doc,data} = this.state
    this.saveStockMixPaint(doc,data)
    setTimeout(()=>{
      let postData = {bf_queue_id:this.state.bf_queue_id}
      StockStore.saveMixpaintQueue('finished',postData,(result)=>{
        if (result.status=='OK') {
          this._notificationSystem.addNotification({
            title:'แจ้งเตือน',
            message: 'ทำรายการเสร็จงานสำเร็จ',
            level: 'info',
            position:'tc'
          });
        }
        setTimeout(()=>{
          this.onCloseClick()
        },1000)
      })
    },1000)
  }

  onRemarkEditMixColorRecordClick(e) {
    let {data,edit_index} = this.state
    data[edit_index] = Object.assign({is_request_edit:true},data[edit_index])
    this.setState({showRemark:false,edit_index:undefined,data:data})
  }

  onShowStockPopup() {
    let {doc,dataSet} = this.state
    dataSet = {
      added_by:'',
      added_date:'',
      barcode:doc.barcode,
      cat_id:doc.stock_category,
      cat_name:'',
      category:doc.stock_category,
      container_quantity:doc.container_quantity,
      container_unit:doc.container_unit,
      cost_per_unit:doc.cost_per_unit,
      description:doc.stock_description,
      error_quantity:doc.error_quantity,
      itemnum:doc.stock_itemnum,
      last_serial_id:'',
      location:doc.location,
      part_type:doc.stock_type,
      price_per_unit:'',
      productcode:doc.barcode,
      quantity:doc.quantity,
      remark:doc.remark,
      shop_list:doc.shop_list,
      thumbnail_url:'',
      unit:doc.unit,
      warning_quantity:doc.warning_quantity
    }
    if (doc.stock_itemnum>0) {
      StockStore.loadImages(doc.stock_type,doc.stock_itemnum,(result)=>{
        this.setState({productImages:result.data.files})
      })
    }
    this.setState({showStockPopup:true,dataSet:dataSet})
  }

  renderHeadTable() {
    let {doc,car_registration_no_list,input,stockApproverList,customerList} = this.state

    return(
            <Form>
              <Row>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>รหัสบาร์โค้ด</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" placeholder="<เลขที่ถูกสร้างอัตโนมัติ>" value={doc.barcode} className="input-dark" />
                      <InputGroup.Addon style={{cursor:'pointer'}} onClick={this.onShowStockPopup.bind(this)}><FontAwesome name='pencil' /></InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>วันที่เบิกผสม<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value={TODAY}  className="input-dark" readOnly={true} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>ชื่ออะไหล่</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" value={doc.stock_description} className="input-dark" readOnly={true}  />
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>ต้นทุนผสมสี</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" value={doc.cost_per_unit}  className="input-dark" readOnly={true} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>ชั้นวาง</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" value={doc.location} className="input-dark" readOnly={true}  />
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>หมายเหตุ</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" value={doc.remark}  className="input-dark" readOnly={true} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>วันที่เริ่มผสมสี</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" value={doc.start_mix_date} className="input-dark" readOnly={true}  />
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>วันที่เสร็จงาน</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" value={doc.end_mix_date}  className="input-dark" readOnly={true} />
                  </FormGroup>
                </Col>
              </Row>
              
              
              <Row>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>ช่างผสมสี<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <CKAutocomplete
                          top={'-35px'}
                          items={customerList}
                          value={doc.mixed_by}
                          onChange={this.onTextChange.bind(this, 'mixed_by')}
                          onSelect={this.onTextSelect.bind(this, 'mixed_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'mixed_by')}
                        />
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>รหัสสีผสม</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value={doc.colorcode} onChange={this.onHeadInputChagne.bind(this,'colorcode')} />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>ผู้ขอเบิกคนแรก<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <CKAutocomplete
                          top={'-35px'}
                          items={customerList}
                          value={doc.request_by}
                          onChange={this.onTextChange.bind(this, 'request_by')}
                          onSelect={this.onTextSelect.bind(this, 'request_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'request_by')}
                          ref='_request_by'
                        />
                  </FormGroup>
                </Col>  
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>ผู้อนุมัติ<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <CKAutocomplete
                          top={'-35px'}
                          items={customerList}
                          value={doc.response_by}
                          onChange={this.onTextChange.bind(this, 'response_by')}
                          onSelect={this.onTextSelect.bind(this, 'response_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'response_by')}
                          ref='_response_by'
                        />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>ทะเบียนรถคันแรก</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                        <CKAutocomplete
                          top={'-35px'}
                          choiceStyle={{width:'350px'}}
                          items={car_registration_no_list}
                          value={doc.car_registration_no}
                          onKeyPress={this.onSearchCarKeyPress.bind(this)}
                          onChange={this.onTextChange.bind(this, 'car_registration_no')}
                          onSelect={this.onTextSelect.bind(this, 'car_registration_no')}
                          ref='_car_registration_no'
                        />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <ControlLabel>{this.state.car_info}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup>
                    <ControlLabel>คำอธิบาย</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <FormControl inputRef={(input) => { this._description = input }} type="text" placeholder="" value={doc.description} onChange={this.onHeadInputChagne.bind(this,'description')} />
                  </FormGroup>
                </Col>
              </Row>
            </Form>
    )
  }

  renderPaging(){
    return (
      <div>
          <div className="text-right">
            <Pagination
              prev="ก่อนหน้า"
              next="ถัดไป"
              first={false}
              last={false}
              ellipsis
              boundaryLinks
              items={this.state.totalPage}
              maxButtons={5}
              activePage={this.state.activePage}
              onSelect={this.handleSelect.bind(this)}
            />
          </div>
        </div>
    )
  }

  render(){
    let {loading,stockShow,clearShow,doc,pullStockShow,bf_queue_id,mpNo,showRemark,_latestEndQuantity,emptyBeginQuantity} = this.state
    let title = (<span><FontAwesome name="list"/>&nbsp;เมนู</span>)
    let showSave = (doc.stock_recordid*1===0)
    var style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '10px 5px 2px 1px',
          fontSize:'30px',
          width:'400px',
          textAlign:'center'
        },
      }
    }
    let {show}  = this.props
    return (
      <div style={{display:show?'block':'none'}}>
        <Box loading={loading}>
          <Box.Header  className='text-center'>
            <Box.Title>
              {this.props.title}
            </Box.Title>
            <Box.Tools className='pull-right' style={{display:'none'}}>
              
              <ButtonToolbar>                                            
                  <Button                             
                  bsStyle={'link'} className='bg-maroon'
                  onClick={this.onPrintClick.bind(this)}
                >
                  <FontAwesome name='print'/>&nbsp;พิมพ์เอกสาร
                </Button>
              </ButtonToolbar>                     
            </Box.Tools> 
          </Box.Header>
          <Box.Body>
            {this.renderHeadTable()}
            {this.renderTable()}
            {this.isLastItemSaved()?this.renderNewItemButton():''} 
            <IframeModal ref='iframe' title='พิมพ์เอกสาร'/>
            <NotificationSystem ref="notificationSystem" style={style}/>
            <ConfirmPopup show={stockShow} 
              title='ยืนยัน' 
              message='ต้องการปรับสต๊อกจากรายการนี้ทั้งหมด?'
              confirmTitle='ยืนยันการทำรายการ'
              onConfirm={this.onConfirmStockSave.bind(this)}
              onHide={()=>{this.setState({stockShow:false})}}        
              /> 
            <ConfirmPopup show={clearShow} 
              title='ยืนยัน' 
              message='ต้องการเริ่มต้นตรวจสต๊อกใหม่?'
              confirmTitle='ยืนยันการทำรายการ'
              onConfirm={this.onConfirmStockClear.bind(this)}
              onHide={()=>{this.setState({clearShow:false})}}        
              /> 
            <PullStock
              show={pullStockShow}
              onHide={this.onHideClick.bind(this)}
              stockType={this.props.stockType}
              onDataChange={this.onDataChange.bind(this)}
            />      
          </Box.Body>    
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
              {bf_queue_id==undefined?'':<Button bsStyle='success' onClick={this.onJobDoneClick.bind(this)}><FontAwesome name='check' />&nbsp;เสร็จงาน</Button>}
              <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
              <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;ปิดเอกสาร</Button>
            </ButtonToolbar>
          </Box.Footer>    
        </Box>    
        <SearchCarButton
          show={this.state.showCar}
          onHide={()=>{this.setState({showCar:false,car_index:undefined})}}
          onSelect={this.onCarSearchSelect.bind(this)}
        />  
        <RemarkRecordModal
          show={showRemark}
          docTitle='แก้ไขรายการเบิกสีผสม'
          docName='newmixcolor'
          docNo={mpNo}
          docTag=''
          onHide={()=>{this.setState({showRemark:false,edit_index:undefined})}}
          onModalClose={()=>{this.setState({showRemark:false,edit_index:undefined})}}
          onSuccess={this.onRemarkEditMixColorRecordClick.bind(this)}
        />  
        <StockEditProductModal
          ref='editProduct'
          show={this.state.showStockPopup}
          onHide={this.onStockEditProductCloseClick.bind(this)}
          tool={doc.stock_type}
          searchType=''
          images={this.state.productImages}
          onCatChange={this.onStockEditProductCategoryChange.bind(this)}
          onTextChange={this.onTextStockEditProductChange.bind(this)}
          onImageUpload={this.onImageUpload.bind(this)}
          // onNewCategory={this.onNewCategory.bind(this)}
          dataSet={this.state.dataSet}
          mixColorUpdateData={this.onUpdateData.bind(this)}
          clearAfterSave={this.onClearAfterSave.bind(this)}
        />
      </div>
    )
  }
}

StockNewMixColorDoc.defaultProps = {
  show:false,
  showHead: true,
  title: 'รายการเบิกสีผสม'
}

export default StockNewMixColorDoc;



// WEBPACK FOOTER //
// ./src/view/stock/StockNewMixColorDoc.js